import { List, ListItem } from '@mui/material';
import React from 'react';
import CustomImg from '../CustomImage/CustomImg';
import CustomTypography, {
    TypographyType,
} from '../Typography/CustomTypography';
import './ListStyle.scss';

export interface ISubMenuItemListProps {
    menuItems: SubMenuItem[];
    getSelectedItems?: () => string[];
}

export type ListItemType = {
    displayText: string;
    id: string;
};

export type SubMenuItem = {
    id: string;
    displayText: string;
    onClickHandler: (item: ListItemType) => void | Promise<void>;
    textColor?: string;
};

function SubMenuList({
    menuItems,
    getSelectedItems,
}: ISubMenuItemListProps): JSX.Element {
    return (
        <List>
            {menuItems.map((item, index) => {
                return (
                    <ListItem
                        component="div"
                        onClick={() => item.onClickHandler(item)}
                        divider
                        key={index}
                        id={item.id ? item.id : `submenu-item-${index}`}
                        className="listItem"
                    >
                        <CustomTypography
                            type={TypographyType.notoSansBody16px}
                            text={item.displayText}
                            textAlign="left"
                            style={{
                                color: item.textColor ? item.textColor : '',
                            }}
                        />
                        <CustomImg
                            hidden={
                                !(
                                    getSelectedItems &&
                                    getSelectedItems().includes(item.id)
                                )
                            }
                            imgType="iconSmall"
                            src="/resources/sharedAcrossWorkflows/selection-tick-mark.svg"
                            alt=""
                        />
                    </ListItem>
                );
            })}
        </List>
    );
}

export default SubMenuList;
